import type {ReadonlySignal} from '@preact/signals-react';
import {useEffect, useState} from 'react';

/**
 * Subscribe to a `@preact/signals-react` signal and return its current value
 * as React state. This ensures the component re-renders when the signal
 * changes, working around the automatic tracking in signals-react v2 which
 * can silently fail depending on the bundler/React version.
 */
export function useSignalValue<T>(signal: ReadonlySignal<T>): T {
  const [value, setValue] = useState(() => signal.value);

  useEffect(() => {
    // Immediately sync in case the signal changed between render and effect
    setValue(signal.value);
    return signal.subscribe(v => setValue(v));
  }, [signal]);

  return value;
}
